import styled from 'styled-components';

export default styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .MuiFormControl-root {
    width: 100%;

    .MuiOutlinedInput-notchedOutline {
      border-width: 1px !important;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${({ theme }) => theme.mainTheme.color.blue50};
      border-width: 1px !important;

      :focus {
        border: 1px solid ${({ theme }) => theme.mainTheme.color.blue50};
      }
    }

    &.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color: #d32f2f;
    }
  }

  .MuiOutlinedInput-root {
    border-radius: ${({ theme }) => theme.borderRadius};
  }

  & .MuiFormHelperText-root {
    margin: 3px 14px 0px;
  }
`;
